<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['shopPayingUserDatas'],
    data() {
        return {
            cumulativeUsersYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 7],
            orderPayCustomerYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1],
            dynamicPayUserYdata: [7, 4, 5, 2, 14, 17, 9, 13, 18, 15, 13, 11],
            xdisplaydata: []
        }
    },
    watch: {
        shopPayingUserDatas(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.shopPayingUserDatas)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(datas) {
            this.xdisplaydata = datas[0].xdisplaydata
            this.cumulativeUsersYdata = datas[1].cumulativeUsersYdata
            this.orderPayCustomerYdata = datas[2].orderPayCustomerYdata
            this.dynamicPayUserYdata = datas[3].dynamicPayUserYdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#409EFF', '#67C23A', '#FACC14'],
                // title: {
                //     subtext: '流量趋势',
                //     left: 'left',
                //     subtextStyle: {
                //         color: '#606266'
                //     }
                // },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['累计付费用户', '付费用户', '活跃付费用户'],
                    // icon: 'circle', // 圆
                    icon: 'diamond', // 菱形
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    data: this.xdisplaydata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '累计付费用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.cumulativeUsersYdata
                    },
                    {
                        name: '付费用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.orderPayCustomerYdata
                    },
                    {
                        name: '活跃付费用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.dynamicPayUserYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>